@if (dataSource) {
  @if (dataSource.hasError$ | async) {
    <ng-container *ngTemplateOutlet="tableError"></ng-container>
  } @else if (
    (dataSource.sortedDownloads$ | async)?.length === 0 &&
    (dataSource.isLoading$ | async) === false
    ) {
    <ng-container *ngTemplateOutlet="tableEmpty"></ng-container>
  } @else {
    <ng-container *ngTemplateOutlet="tableResponsive"></ng-container>

    <download-portal-loader
      [isLoading]="(dataSource.isLoading$ | async) || false"
    ></download-portal-loader>
  }
}

<ng-template #tableResponsive>
  <div class="relative">
    <table
      mat-table
      matSort
      multiTemplateDataRows
      [dataSource]="dataSource"
      [attr.aria-label]="tableAriaLabel"
      class="mat-elevation-z8"
      >
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Programmname</th>
        <th
          mat-cell
          scope="row"
          class="download-name-cell mat-mdc-cell mdc-data-table__cell mat-column-name"
          *matCellDef="let download; let i = dataIndex"
          [ngClass]="{
            'highlight-cell': selectedDownload?.id === download.id,
          }"
          >
          @if (!platform.SAFARI) {
            <span
              #rowFocus
              class="absolute inset-0 z-[2]"
              role="button"
              [tabindex]="activeRowIndex === i ? 0 : -1"
              (focus)="activeRowIndex = i"
              (click)="onRowSelection.emit(download)"
              (keyup.Space)="onRowSelection.emit(download)"
              (keyup.enter)="onRowSelection.emit(download)"
              (keydown.arrowDown)="focusRow(i + 1, $event)"
              (keydown.arrowUp)="focusRow(i - 1, $event)"
              (keydown.home)="focusRow(0, $event)"
              (keydown.end)="focusRow(rowCount - 1, $event)"
              [attr.aria-labelledby]="getOverlayButtonLabelledBy(i)"
            ></span>
          }
          <span [class]="largeDisplayTableCellClass" [attr.id]="getDownloadNameId(i)">
            {{ download.name }}
          </span>
          <span [class]="smallDisplayTableCellClass">
            <ng-container
              [ngTemplateOutlet]="collapsedDownloadRowDisplay"
              [ngTemplateOutletContext]="{ download: download, index: i }"
            ></ng-container>
          </span>
        </th>
      </ng-container>

      <ng-container matColumnDef="version">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Version</th>
        <td
          mat-cell
          *matCellDef="let download; let i = dataIndex"
          [ngClass]="{
            'highlight-cell': selectedDownload?.id === download.id,
          }"
          >
          <span [class]="largeDisplayTableCellClass">
            {{ download.version }}
          </span>
          <span [class]="smallDisplayTableCellClass">
            <ng-container
              [ngTemplateOutlet]="collapsedDownloadRowDisplay"
              [ngTemplateOutletContext]="{ download: download, index: i }"
            ></ng-container>
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="published_date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Datum</th>
        <td
          mat-cell
          *matCellDef="let download; let i = dataIndex"
          [ngClass]="{
            'highlight-cell': selectedDownload?.id === download.id,
          }"
          >
          <span [class]="largeDisplayTableCellClass">
            {{ download.published_date | date: 'dd.MM.yyyy' }}
          </span>
          <span [class]="smallDisplayTableCellClass">
            <ng-container
              [ngTemplateOutlet]="collapsedDownloadRowDisplay"
              [ngTemplateOutletContext]="{ download: download, index: i }"
            ></ng-container>
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="productGroupLabel">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Produktgruppe</th>
        <td
          mat-cell
          *matCellDef="let download; let i = dataIndex"
          [ngClass]="{
            'highlight-cell': selectedDownload?.id === download.id,
          }"
          >
          <span [class]="largeDisplayTableCellClass">
            @if (isProduct(download)) {
              @if (download.productGroupLabel) {
                <mat-chip>
                  <span class="text-xs">
                    {{ download.productGroupLabel }}
                  </span>
                </mat-chip>
              }
            }
          </span>
          <span [class]="smallDisplayTableCellClass">
            <ng-container
              [ngTemplateOutlet]="collapsedDownloadRowDisplay"
              [ngTemplateOutletContext]="{ download: download, index: i }"
            ></ng-container>
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="more">
        <th mat-header-cell *matHeaderCellDef>
          <span class="sr-only">Aktion</span>
        </th>
        <td
          mat-cell
          *matCellDef="let download"
          [ngClass]="{
            'highlight-cell': selectedDownload?.id === download.id,
          }"
          >
          <div class="flex items-center justify-end gap-2 font-semibold">
            <span class="hidden md:block">Mehr</span>
            <mat-icon
              svgIcon="sli-pfeil-rechts-20"
              class="cursor-pointer"
            ></mat-icon>
          </div>
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns$ | ngrxPush; sticky: true"
      ></tr>
      @if (!platform.SAFARI) {
        <tr
          class="cursor-pointer relative"
          mat-row
          [ngClass]="{
            'selected-row': selectedDownload?.id === download.id,
            '!bg-coldgray-150': selectedDownload?.id === download.id,
          }"
          *matRowDef="let download; columns: displayedColumns$ | ngrxPush"
          [attr.aria-selected]="selectedDownload?.id === download.id"
        ></tr>
      } @else {
        <tr
          class="cursor-pointer"
          mat-row
          (click)="onRowSelection.emit(download)"
          (keyup.Space)="onRowSelection.emit(download)"
          (keyup.enter)="onRowSelection.emit(download)"
          [ngClass]="{
            'selected-row': selectedDownload?.id === download.id,
            '!bg-coldgray-150': selectedDownload?.id === download.id,
          }"
          *matRowDef="let download; columns: displayedColumns$ | ngrxPush"
          [attr.aria-selected]="selectedDownload?.id === download.id"
        ></tr>
      }
    </table>

    @if (showLoadMoreButton && (dataSource.isLoading$ | async) === false) {
      <div class="flex justify-center py-4">
        <button mat-button color="secondary" (click)="loadMore()">
          Mehr laden
        </button>
      </div>
    }
  </div>
</ng-template>

<ng-template
  #collapsedDownloadRowDisplay
  let-download="download"
  let-index="index"
>
  <div class="py-3">
    @if ((isTableDisplay$ | async) === false && !platform.SAFARI) {
      <span
        #rowFocus
        class="absolute inset-0 z-[2]"
        role="button"
        [tabindex]="activeRowIndex === index ? 0 : -1"
        (focus)="activeRowIndex = index"
        (click)="onRowSelection.emit(download)"
        (keyup.Space)="onRowSelection.emit(download)"
        (keyup.enter)="onRowSelection.emit(download)"
        (keydown.arrowDown)="focusRow(index + 1, $event)"
        (keydown.arrowUp)="focusRow(index - 1, $event)"
        (keydown.home)="focusRow(0, $event)"
        (keydown.end)="focusRow(rowCount - 1, $event)"
        [attr.aria-labelledby]="getOverlayButtonLabelledBy(index, true)"
      ></span>
    }
    <div class="grid grid-cols-[auto_20px] gap-3">
      <div class="flex flex-col gap-2">
        <p class="font-semibold" [attr.id]="getDownloadNameId(index, true)">
          {{ download.name }}
        </p>
        <p>
          <span class="text-sm text-black text-opacity-70">Version:</span>
          <span>
            {{ download.version }}
          </span>
        </p>
        <p>
          <span class="text-sm text-black text-opacity-70">Datum:</span>
          <span>
            {{ download.published_date | date: 'dd.MM.yyyy' }}
          </span>
        </p>
        @if (isProduct(download)) {
          <p>
            <span class="text-sm text-black text-opacity-70">
              Produktgruppe:
            </span>
            <span>
              @if (download.productGroupLabel) {
                <mat-chip>
                  <span class="text-xs">
                    {{ download.productGroupLabel }}
                  </span>
                </mat-chip>
              }
            </span>
          </p>
        }
      </div>
      <div class="flex items-center justify-end">
        <mat-icon
          svgIcon="sli-pfeil-rechts-20"
          class="cursor-pointer"
        ></mat-icon>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #tableEmpty>
  <dackl-empty-state image="no-matches" size="XS">
    @if (isOnSmeListPage$ | async) {
      <h3 class="heading-3 mb-2">Keine Daten vorhanden</h3>
    } @else {
      <h2 class="heading-3 mb-2">Keine Daten vorhanden</h2>
    }
    <p class="text-center">Keine Downloads gefunden.</p>
  </dackl-empty-state>
</ng-template>

<ng-template #tableError>
  <dp-internal-server-error
    (onReloadClick)="retryOnError()"
  ></dp-internal-server-error>
</ng-template>
